/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import ReportCard from 'shared/ui/components/analytics/ReportCard.vue';

/**
 * @typedef {import('./ReportCard.vue').ReportCardProps} ReportCardProps
 * @typedef {{ name: string, label: string, reports: ReportCardProps }} Block
 */

const __vue_script__ = {
    name: 'ReportListDisplay',

    components: { ReportCard },

    props: {
        /** @type {Block[]} */
        blocks: {
            type: Array,
            default: () => [],
        },

        event: {
            type: Object,
            required: true,
        },
    },
    computed: {
        hasVisibleReports() {
            return !!this.blocks.some(({ reports }) => reports.length);
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "reports-list-display" },
    [
      _vm.hasVisibleReports
        ? [
            _c("h2", [_vm._v(_vm._s(_vm.$t("analytics.reports_list")))]),
            _c("p", [_vm._v(_vm._s(_vm.$t("analytics.reports_description")))]),
          ]
        : _vm._e(),
      _vm._t("default"),
      _vm._l(_vm.blocks, function (block) {
        return _c(
          "div",
          { key: block.name, staticClass: "report-block" },
          [
            block.reports.length
              ? [
                  _c("h3", [_vm._v(_vm._s(block.label))]),
                  _c(
                    "section",
                    { staticClass: "reports" },
                    _vm._l(block.reports, function (report) {
                      return _c(
                        "report-card",
                        _vm._b(
                          { key: report.name, attrs: { event: _vm.event } },
                          "report-card",
                          report,
                          false
                        )
                      )
                    }),
                    1
                  ),
                ]
              : _vm._e(),
          ],
          2
        )
      }),
    ],
    2
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/shared/src/ui/components/analytics/ReportListDisplay.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__